import React, { useEffect, useState } from "react";
import "./Footer.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  lilo_logo_02,
  play_store,
  app_store,
  instagramicon,
  facebookicon,
  youtubeicon,
  playstore,
  appstoreicon,
  fssailogo,
} from "../../assets/images";
import { Link, useLocation } from "react-router-dom";
import { sendEventToServer } from "../../hooks/sendEventToServer";
import { useSelector } from "react-redux";
import { guestId } from "../../services/apiConfig";
const footerquicklinks = [
  {
    label: "Home",
    value: "Home",
    navlink: "/",
  },
  {
    label: "Fresh Fish",
    value: "Freshfish",
    navlink: "/FreshFish",
  },
  // {
  //   label: "Food",
  //   value: "food",
  //   // navlink: "/Food",
  //   navlink: "/ComingSoon",
  // },
  {
    label: "Poultry",
    value: "Poultry",
    // navlink: "/Food",
    navlink: "/Meat",
  },
  {
    label: "Organic",
    value: "organic",
    // navlink: "/Grocery",
    navlink: "/ComingSoon",
  },
  // {
  //   label: "Offers",
  //   value: "offers",
  //   navlink: "/",
  // },
  {
    label: "History",
    value: "history",
    navlink: "/History",
  },
];
const footerlegal = [
  {
    label: "Privacy Policy",
    value: "PrivacyPolicy",
    navlink: "/PrivacyPolicy",
  },
  {
    label: "Terms & Conditions",
    value: "TermsConditions",
    navlink: "/TermsConditions",
  },
  {
    label: "Cookie Policy",
    value: "CookiePolicy",
    navlink: "/CookiePolicy",
  },
  {
    label: "Refund & Cancellation Policy",
    value: "RefundCancellation",
    navlink: "/RefundCancellation",
  },
];
interface FooterProps {
  currentPage: string;
  setCurrentPage: (page: string) => void;
  footerSelectPage?: string;
}
const Footer: React.FC<FooterProps> = ({ currentPage, setCurrentPage }) => {
  const [selecetedNav, setSelecetdNav] = useState("Home");

  const handleSetActiveNavigation = (nav: string) => {
    setSelecetdNav(nav);
    setCurrentPage(nav);
  };

  const { customerId } = useSelector((state: any) => state.auth);

  useEffect(() => {
    setSelecetdNav(currentPage);
  }, [currentPage]);

  const path_location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(path_location.search);
    const planet = queryParams.get("Planet");
    if (path_location.pathname === "/") {
      setSelecetdNav("Home");
    } else if (
      path_location.pathname === "/FreshFish" ||
      planet === "fishPlanet" ||
      path_location.pathname === "/FishCategory"
    ) {
      setSelecetdNav("Freshfish");
    } else if (
      path_location.pathname === "/Meat" ||
      planet === "meatPlanet" ||
      path_location.pathname === "/MeatCategory"
    ) {
      setSelecetdNav("Poultry");
    } else if (path_location.pathname === "/ComingSoon") {
      setSelecetdNav("organic");
    } else if (path_location.pathname === "/History") {
      setSelecetdNav("history");
    } else if (path_location.pathname === "/PrivacyPolicy") {
      setSelecetdNav("PrivacyPolicy");
    } else if (path_location.pathname === "/TermsConditions") {
      setSelecetdNav("TermsConditions");
    } else if (path_location.pathname === "/CookiePolicy") {
      setSelecetdNav("CookiePolicy");
    } else if (path_location.pathname === "/RefundCancellation") {
      setSelecetdNav("RefundCancellation");
    } else {
      setSelecetdNav("");
    }
  }, [path_location.pathname]);

  return (
    <div className="footer-container">
      <div className="container-fluid footer-container d-flex justify-content-center text-start pb-4">
        <div className="row list-row width-full-page pt-4">
          <div className="col-md-7 my-custom-margin pt-3">
            <div className="row">
              <div className="col-6">
                <ul className="list">
                  <li>
                    <h5 className="footer-heading-links">Quick Links</h5>
                  </li>
                  {footerquicklinks.map((item) => (
                    <li onClick={() => handleSetActiveNavigation(item.value)}>
                      <Link
                        className={` footer-link ${
                          selecetedNav === item.value ? "footeractive" : ""
                        }`}
                        to={item.navlink}
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="col-6">
                <ul className="list">
                  <li>
                    <h5 className="footer-heading-links">Legal</h5>
                  </li>
                  {footerlegal.map((item) => (
                    <li onClick={() => handleSetActiveNavigation(item.value)}>
                      <Link
                        className={` footer-link ${
                          selecetedNav === item.value ? "footeractive" : ""
                        }`}
                        to={item.navlink}
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-5 pt-3">
            <div>
              <img
                src={lilo_logo_02}
                alt="Logo"
                className="img-fluid footer-logo"
              />
            </div>
            <div className="footer-text d-flex align-items-center pt-2">
              <img
                src={fssailogo}
                alt="fssailogo"
                className="fssailogo img-fluid"
              />
              <span className="ps-2">Lic. No. 11324999000396</span>
            </div>
            <div className="row">
              <div className="col-6 ">
                <Link
                  to="https://play.google.com/store/apps/details?id=com.livelocal.consumerapp"
                  onClick={(e) => {
                    e.preventDefault(); // Prevents immediate redirection
                    sendEventToServer({
                      NAME: "CONSUMER_WEB_REDIRECT_TO_PLAYSTORE",
                      CUSTOMER_ID: customerId || guestId,
                      MODULE: "GOOGLE PLAYSTORE REDIRECTION",
                      PAYLOAD: {},
                      EVENT_CATEGORY: "INFO",
                      MERCHANT_ID: "",
                    });
                    setTimeout(() => {
                      window.location.href =
                        "https://play.google.com/store/apps/details?id=com.livelocal.consumerapp";
                    }, 500); // Delay to ensure the event is sent before redirection
                  }}
                >
                  <button className=" footer-btn-app-link mt-3">
                    <img src={playstore} alt="playstore" />
                    <span className="">&nbsp;Google Play</span>
                  </button>
                </Link>
              </div>
              <div className="col-6">
                <Link
                  to="https://apps.apple.com/in/app/lilo-livelocal/id6473018597"
                  onClick={(e) => {
                    e.preventDefault(); // Prevents immediate redirection
                    sendEventToServer({
                      NAME: "CONSUMER_WEB_REDIRECT_TO_APPSTORE",
                      CUSTOMER_ID: customerId || guestId,
                      MODULE: "APPSTORE REDIRECTION",
                      PAYLOAD: {},
                      EVENT_CATEGORY: "INFO",
                      MERCHANT_ID: "",
                    });
                    setTimeout(() => {
                      window.location.href =
                        "https://apps.apple.com/in/app/lilo-livelocal/id6473018597";
                    }, 500); // Delay to ensure the event is sent before redirection
                  }}
                >
                  <button className=" footer-btn-app-link mt-3">
                    <img src={appstoreicon} alt="appstoreicon" />
                    <span className="">&nbsp;App Store</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
          {/* <div className="col-md-4 my-custom-margin align-content-center pt-3">
            <div className="footer-text-right">Subscribe to our Newsletter</div>
            <div className="input-group mb-3 pt-4">
              <input
                type="text"
                className="form-control input-footer"
                placeholder="Email"
                aria-label="Email"
                aria-describedby="basic-addon2"
              />
              <div className="input-group-append">
                <button className="btn subscribe-button" type="button">
                  Subscribe
                </button>
              </div>
            </div>
            <div>
              <img
                src={lilo_logo_02}
                alt="Logo"
                className="img-fluid footer-logo"
              />
            </div>
            <div className="footer-text d-flex align-items-center pt-2">
              <img
                src={fssailogo}
                alt="fssailogo"
                className="fssailogo img-fluid"
              />
              <span className="ps-2">Lic. No. 11324999000396</span>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <Link to="https://play.google.com/store/apps/details?id=com.livelocal.consumerapp">
                  <button className=" footer-btn-app-link mt-3">
                    <img src={playstore} alt="playstore" />
                    <span className="">&nbsp;Google Play</span>
                  </button>
                </Link>
              </div>
              <div className="col-lg-6">
                <Link to="https://apps.apple.com/in/app/lilo-livelocal/id6473018597">
                  <button className=" footer-btn-app-link mt-3">
                    <img src={appstoreicon} alt="appstoreicon" />
                    <span className="">&nbsp;App Store</span>
                  </button>
                </Link>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div className="pt-4 d-flex justify-content-center footer-credit-text-div px-2">
        <div className="width-full-page text-center footer-credit-text pb-4 d-flex">
          <div className="col text-start">©2024 | All rights reserved</div>
          <div className="col text-end">
            <Link to="https://www.instagram.com/lilo_india" className="px-2">
              <img
                src={instagramicon}
                alt="instagramicon"
                className="img-fluid"
              />
            </Link>
            <Link
              to="https://www.facebook.com/share/PeCiRi1XAyKFhGZY/?mibextid=LQQJ4d"
              className="px-2"
            >
              <img
                src={facebookicon}
                alt="facebookicon"
                className="img-fluid"
              />
            </Link>
            <Link to="https://www.youtube.com/@Live_Local" className="px-2">
              <img src={youtubeicon} alt="youtubeicon" className="img-fluid" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
